module.exports = __webpack_public_path__ + "img/vehicle-slides-with-backdrop-kia.77601f73.png";